import React, { createContext, useContext, useState, useCallback } from 'react';

// Create a context to manage refresh state
const RefreshContext = createContext();

export const useRefresh = () => useContext(RefreshContext);

export const RefreshProvider = ({ children }) => {
  const [refresh, setRefresh] = useState(0);

  const triggerRefresh = useCallback(() => {
    setRefresh((prev) => prev + 1);
  }, []);

  return (
    <RefreshContext.Provider value={{ refresh, triggerRefresh }}>
      {children}
    </RefreshContext.Provider>
  );
};